import React, { useEffect, useState } from "react";
import { TreeSelect, message } from "antd";
import { FolderOutlined, FunctionOutlined } from '@ant-design/icons';
import useRequest from "@/utils/useRequest";
import _ from "lodash";

function list_to_tree(list, onlySelectFunctions = false) {
  var map = {}, node, roots = [], i;
  var ids = new Set(); // 用于存储所有节点Id

  // 遍历一遍列表，获取所有节点的Id
  for (i = 0; i < list.length; i += 1) {
    ids.add(list[i].Id);
  }

  // 遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    map[list[i].Id] = i; // initialize the map
    list[i].key = list[i].Id;
    
    // 根据onlySelectFunctions设置目录项的样式
    const isDisabled = onlySelectFunctions;
    list[i].title = (
      <span style={{ color: isDisabled ? '#d9d9d9' : 'inherit' }}>
        <FolderOutlined style={{ 
          marginRight: 8, 
          color: isDisabled ? '#d9d9d9' : '#1890ff' 
        }} />
        {list[i].Name}
      </span>
    );
    list[i].value = list[i].Id;
    list[i].children = []; // initialize the children
    list[i].disabled = isDisabled; // 禁用目录项
    list[i].checkable = !isDisabled; // 设置是否可勾选
    
    // 如果有FuncInfos，添加功能节点作为子节点
    if (list[i].FuncInfos && list[i].FuncInfos.length > 0) {
      list[i].FuncInfos.forEach(func => {
        list[i].children.push({
          key: `${list[i].Id}_${func.Id}`,
          title: (
            <span>
              <FunctionOutlined style={{ marginRight: 8, color: '#52c41a' }} />
              {func.FuncName}
            </span>
          ),
          value: `${list[i].Id}_${func.Id}`,
          isLeaf: true,
          funcId: func.Id,
          menuId: list[i].Id,
          disabled: false,
          checkable: true
        });
      });
    }

    // 检查父节点是否存在于ids集合中，如果不存在则将该节点作为根节点处理
    if (list[i].ParentId !== null && !ids.has(list[i].ParentId)) {
      roots.push(list[i]);
    }
  }

  // 再次遍历列表，构建树形结构
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.ParentId !== null && ids.has(node.ParentId)) {
      list[map[node.ParentId]].children.push(node);
    } else if (node.ParentId === null) {
      roots.push(node);
    }
  }

  return roots;
}

const MenuFuncSelect = (props) => {
  const { value, onChange, onlySelectFunctions = false } = props;
  const [loading, setLoading] = useState(false);
  const [gData, setData] = useState([]);
  const { request } = useRequest();

  const Refresh = async () => {
    setLoading(true);
    try {
      let result = await request("/api/v2/private/menu/all", "GET", "json", {});
      if (result.success) {
        // 组装成树形结构，传入onlySelectFunctions参数
        let tree = list_to_tree(_.sortBy(result.data, "SortNum"), onlySelectFunctions);
        setData(tree);
      } else {
        message.error("获取菜单数据失败");
      }
    } catch (error) {
      message.error("获取菜单数据失败");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Refresh();
  }, [onlySelectFunctions]); // 添加onlySelectFunctions依赖

  const handleChange = (selectedValues) => {
    if (onChange) {
      if (onlySelectFunctions) {
        // 只保留功能节点的选择（包含下划线的值）
        const filteredValue = selectedValues.filter(v => v.includes('_'));
        onChange(filteredValue);
      } else {
        onChange(selectedValues);
      }
    }
  };

  return (
    <TreeSelect
      placeholder="请选择菜单功能..."
      multiple
      value={value}
      treeDefaultExpandAll
      onChange={handleChange}
      treeData={gData}
      loading={loading}
      showCheckedStrategy={onlySelectFunctions ? TreeSelect.SHOW_CHILD : TreeSelect.SHOW_ALL}
      treeCheckable={true}
      maxTagCount="responsive"
      treeNodeFilterProp="title"
      showSearch
      allowClear
      style={{ width: '100%' }}
    />
  );
};

export default MenuFuncSelect;